import clsx from 'clsx';
import React from 'react';

import { YOUTUBE_URL, backgroundColorValues, marginValues, paddingValues } from './constants';
import type { VideoBlockProps } from './interfaces';

const VideoBlock = ({ config, content }: VideoBlockProps) => {
  if (!content.src) return null;

  const isYouTubeURL = content.src?.includes(YOUTUBE_URL);
  const width = Number(config?.width);
  const maxWidth = width && !isNaN(width) ? `max-w-[${width}px]` : '';

  if (isYouTubeURL) {
    return (
      <iframe
        src={content.src}
        className={clsx(
          'video-block mt-24 h-auto w-full border-0',
          maxWidth,
          content?.yt_short ? 'aspect-[9/16]' : 'aspect-[16/9]',
          config?.css_classes
        )}
        title="YouTube video player"
        allow="accelerometer; autoplay; encrypted-media; gyroscope;"
        referrerPolicy="strict-origin-when-cross-origin"
        allowFullScreen
      />
    );
  }

  return (
    <figure className={clsx('Video-block-with-caption relative m-0 w-full *:w-full', maxWidth)}>
      <video
        className={clsx(
          'Video-block mb-0 mt-24 w-full',
          config?.css_classes,
          !content?.caption && maxWidth,
          backgroundColorValues[config?.background_color],
          marginValues[config?.margin],
          paddingValues[config?.padding]
        )}
        {...(config?.controls && { controls: true })}
        {...(config?.loop && { loop: true })}
        {...(config?.muted && { muted: true })}
        poster={config?.poster}
        preload={config?.preload}
        {...(config?.playsinline && { playsInline: true })}
        src={content.src}
      />
      {content?.caption && <figcaption className="text-caption-md">{content.caption}</figcaption>}
    </figure>
  );
};

export default VideoBlock;
